import { createTheme } from '@mui/material';

import { palette } from './palette';
import { baseTheme } from './baseTheme';

export const theme = createTheme(baseTheme, {
  palette,
});
